const CURRENCIES = { USD: "USD", EUR: "EUR", GBP: "GBP" } as const;
export const CURRENCIES_SYMBOLS = { USD: "$", EUR: "€", GBP: "£" };
export default CURRENCIES;
